var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDemo3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 90,
    height: 90,
    rx: 45,
    fill: "#FFF1C5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.9639 25.5986C40.801 24.0093 45.0232 23.5931 49.0967 24.4033C53.1703 25.2136 56.9127 27.2135 59.8496 30.1504C62.7865 33.0873 64.7864 36.8297 65.5967 40.9033C66.4069 44.9768 65.9907 49.199 64.4014 53.0361C62.8119 56.8734 60.1204 60.1534 56.667 62.4609C53.4294 64.6243 49.6584 65.8416 45.7773 65.9854L45 66H44.999C41.7552 66.0016 38.5548 65.2512 35.6494 63.8086C34.0197 62.9975 32.2397 63.2162 30.8154 63.5654C30.0824 63.7452 29.3646 63.981 28.7256 64.1953C28.0626 64.4176 27.5057 64.6084 27.002 64.7432C26.7603 64.8079 26.5053 64.8089 26.2637 64.7441C26.0221 64.6794 25.8018 64.5518 25.625 64.375C25.4482 64.1982 25.3206 63.9779 25.2559 63.7363C25.2073 63.5551 25.1955 63.3664 25.2197 63.1816L25.2568 62.998C25.3916 62.4945 25.5824 61.938 25.8047 61.2754C26.0191 60.6362 26.2556 59.9178 26.4355 59.1846C26.7852 57.76 27.0039 55.9797 26.1934 54.3496L26.1924 54.3477L25.9365 53.8164C24.6933 51.1369 24 48.1526 24 45C24 40.8466 25.2316 36.7864 27.5391 33.333C29.8466 29.8796 33.1266 27.1881 36.9639 25.5986Z",
    stroke: "#FFAE00",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDemo3);
export default __webpack_public_path__ + "static/media/demo3.d07cfb015dd103aa68c7f8cb4767f476.svg";
export { ForwardRef as ReactComponent };